import { gql } from "@apollo/client";
import { alpha } from "@mui/material";
import { COLOR_BLACK, COLOR_BLACK_LIGHTER, COLOR_WHITE_LIGHTER } from "helpers/colors";
import useData from "helpers/useData";
import Splash from "molecules/Splash";
import Subnav, { SubnavDropdown, SubnavDropdownItem, SubnavToggleLabel } from "molecules/Subnav";
import React from "react";

export default function PersonPagesHeader({ personId, tab }) {
  const [data] = useData(
    gql`
      query PersonPagesHeader($personId: ID!) {
        person(id: $personId) {
          id
          fullNameWithAnonymisation
          canOnsenPersonPageSettings
          org {
            id
            name
          }
        }
        currentUser {
          id
          people {
            id
            fullNameWithAnonymisation
            org {
              id
              name
            }
          }
          supportingPeople {
            id
            fullNameWithAnonymisation
            org {
              id
              name
            }
          }
        }
      }
    `,
    { personId },
  );

  return (
    <>
      <Splash
        color={COLOR_BLACK_LIGHTER}
        title={data?.person?.fullNameWithAnonymisation}
        descriptionHeader="Organisation"
        descriptionValue={data?.person?.org?.name}
      />
      <div
        style={{
          backgroundColor: COLOR_WHITE_LIGHTER,
          borderBottom: `1px solid ${alpha(COLOR_BLACK, 0.1)}`,
        }}
      >
        <Subnav wrap={false}>
          <SubnavDropdown text={data?.person?.fullNameWithAnonymisation}>
            {[...(data?.currentUser?.people || []), ...(data?.currentUser?.supportingPeople || [])].map((person) => (
              <SubnavDropdownItem
                key={person.id}
                text={person.fullNameWithAnonymisation}
                description={person.org.name}
                selected={person.id === personId}
                href={`/person/${person.id}`}
              >
                {person.fullNameWithAnonymisation}
              </SubnavDropdownItem>
            ))}
          </SubnavDropdown>
          <SubnavToggleLabel text="Profile" checked={tab === "profile"} href={`/person/${personId}`} />
          {data?.person?.canOnsenPersonPageSettings && (
            <SubnavToggleLabel text="Settings" checked={tab === "settings"} href={`/person/${personId}/settings`} />
          )}
        </Subnav>
      </div>
    </>
  );
}
